import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { MyDocsService } from '../../service/mydocs.service';
import { MyDocsModel } from '../../models/upload/mydocs.model';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpErrorResponse, HttpEventType, HttpResponse } from '@angular/common/http';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { GlobalService } from 'src/app/service/global.service';
import { DomSanitizer } from '@angular/platform-browser';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';


@Component({
  selector: 'app-user-doc-mapping',
  templateUrl: './user-doc-mapping.component.html',
  styleUrls: ['./user-doc-mapping.component.css']
})
export class UserDocMappingComponent implements OnInit {

  public myDocsModel = new MyDocsModel();

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private myDocsService: MyDocsService,
    private notificationService: NotificationService,
    private exportExcelService: ExportExcelService
  ) { }

  control = new FormControl();
  filteredStreets: Observable<MyDocsModel[]> | undefined;
  filteredValues: MyDocsModel[] = [];

  selectedFiles: FileList;
  currentFile: File;
  id: any;

  docNames: MyDocsModel[] = [];
  isChkd: string = '';
  isAssign: boolean = true;
  isUpload: boolean = false;
  editMode: boolean = false;

  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  mySalesChannelSet = new Set<string>();

  userDocMapData: MyDocsModel[] = [];
  selectedUserDoc: MyDocsModel[] = [];

  isAccessDisabled: boolean = false;

  // Grid table configuration
  userDocTableColumns: TableColumn[];
  actions: TableColumn[] = [];
  actionButtons: TableColumn[] = [];
  selectedUserDocuments: MyDocsModel[] = [];
  headerCheckboxSelected : boolean =false;
  showTable= true;


  // For file upload modal
  uploadRow: any = null;
  uploadFile: File | null = null;

  // For edit modal
  editRow: MyDocsModel | null = null;

  // Commission plans for dropdown
  commissionPlans: any[] = [];

  // Add Document functionality (embedded from add-commission-doc)
  addDocSelectedFiles: FileList;
  addDocCurrentFile: File;
  addDocProgress = 0;
  addDocMessage = '';
  public commPlanDescData: MyDocsModel[] = [];
  public salesChannelsData: MyDocsModel[] = [];
  public addDocModel = new MyDocsModel();
  public showAddDocForm: boolean = false;

  ngOnInit() {
    this.isAccessDisabled = this.globalService._permissionCheck('user-doc-mapping');
    this.editMode = false;
    this.docNames = [];
    this.filteredStreets = this.control.valueChanges.pipe(
      startWith(''),
      map(value => value.length >= 3 ? this._filter(value) : this.filterDocNames(value.length))
    );

    this.initializeColumns();
    this.initializeGridConfiguration();

    this.loadCommissionPlans();
    this.getMyDocsList();
    this.getSalesChannelsList();
  }

  public updateDocs() {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      for (let updatePlan of this.filteredValues) {
        if (updatePlan.editMode) {
          this.selectedUserDoc.push(updatePlan);
        }
      }

      this.selectedUserDoc[0].updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
      this.myDocsService.updateDocs(this.selectedUserDoc)
        .subscribe(response => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Updated Successfully');
          this.getMyDocsList();
          this.selectedUserDoc = [];
        }, (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.message || 'Update failed');
        })
    }
  }

  selectFile(event, id) {
    this.selectedFiles = event.target.files;
    this.currentFile = this.selectedFiles.item(0);
    this.id = id;
    this.uploadDocs();
  }

  public redirect(url: string) {
    if (url === "view-user-doc") {
      this.myDocsService.myDocsModel = this.myDocsModel;
      this.myDocsService.mySalesChannelSet = this.mySalesChannelSet;
      this.router.navigate(['/' + url]);
    } else {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.myDocsService.myDocsModel = this.myDocsModel;
        this.myDocsService.mySalesChannelSet = this.mySalesChannelSet;
        this.router.navigate(['/' + url]);
      }
    }
  }

isFormValid(): boolean {
  const model = this.addDocModel;
  return (
    model?.doc_name?.trim() &&
    model?.doc_desc?.trim() &&
    model?.effective_dt &&
    model?.salesChannelDesc &&
    model?.comm_plan_id &&
    this.addDocSelectedFiles?.length > 0
  ) ? true : false;
}

  uploadDocs() {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      this.currentFile = this.selectedFiles.item(0);
      this.myDocsService.uploadSingleDoc(this.currentFile, this.id).subscribe(
        event => {
        },
        err => {
          this.currentFile = undefined;
        });

      this.selectedFiles = undefined;
    }
  }

  public selectedDoc(userdoc: MyDocsModel, values: any) {
    const idx = this.docNames.findIndex(doc => doc.doc_name === userdoc.doc_name);
    if (idx !== -1) {
      this.docNames[idx].editMode = values.currentTarget.checked;
    }
    if (values.currentTarget.checked) {
      this.selectedUserDoc.push(this.docNames[idx]);
      this.isUpload = true;
    } else {
      this.selectedUserDoc = this.selectedUserDoc.filter(doc => doc.doc_name !== userdoc.doc_name);
      this.isAssign = false;
      if (idx !== -1) {
        this.docNames[idx].editMode = false;
      }
    }

    if (this.selectedUserDoc.length == 0)
      this.isUpload = false;

    if (this.selectedUserDoc.length > 1 || this.selectedUserDoc.length == 0) {
      this.isAssign = true;
    } else if (this.selectedUserDoc.length == 1) {
      this.isAssign = false;
      this.isUpload = true;
    }
  }

  public getMyDocsList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getMyDocsList().subscribe(
        (response: MyDocsModel[]) => {
          this.userDocMapData = response.map(doc => {
            let mappedStatus = 'Inactive';
            if (doc.status !== null && doc.status !== undefined) {
              const statusLower = doc.status.toString().toLowerCase().trim();
              if (statusLower === 'active' ||
                statusLower === 'y' ||
                statusLower === '1' ||
                statusLower === 'true' ||
                statusLower === 'enabled' ||
                statusLower === 'on') {
                mappedStatus = 'Active';
              } else if (statusLower === 'inactive' ||
                statusLower === 'n' ||
                statusLower === '0' ||
                statusLower === 'false' ||
                statusLower === 'disabled' ||
                statusLower === 'off') {
                mappedStatus = 'Inactive';
              }
            }
            return {
              ...doc,
              status: mappedStatus
            };
          });

          this.filterActiveDocuments(); // Initially show only active documents
          this.refreshing = false;
          this.isAssign = true;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.message || 'Failed to load documents');
        }
      )
    );
  }

  private _filter(value: string): MyDocsModel[] {
    const filterValue = this._normalizeValue(value);
    this.filteredValues = this.userDocMapData.filter(doc => this._normalizeValue(doc.doc_name).includes(filterValue));
    this.docNames = this.filteredValues;
    if (this.docNames.length === 1) { this.isChkd = 'checked' }
    return this.filteredValues;
  }

  private _normalizeValue(value: string): string {
    if (!value) return '';
    return value.toLowerCase().replace(/\s/g, '');
  }

  public filterDocNames(val: number) {
    if (val === 0)
      this.docNames = this.userDocMapData;
    return [];
  }

  showPdf(comm_doc: string, doc_name: string) {
    if (!comm_doc) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'No document available for this row.');
      return;
    }
    const pdfWindow = window.open('');
    if (!pdfWindow) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Popup blocked! Please allow popups for this site.');
      return;
    }
    pdfWindow.document.write(`
      <html>
        <head>
          <title>${doc_name || 'Document'}</title>
          <style>body{margin:0;}embed{border-width:0;}</style>
        </head>
        <body>
          <embed width="100%" height="100%" src="data:application/pdf;base64,${comm_doc}#toolbar=0&navpanes=0&scrollbar=0"></embed>
        </body>
      </html>
    `);
  }

  private viewDocumentById(docId: number | string, docName: string): void {
    if (!docId) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'No document available for this row.');
      return;
    }
    this.myDocsService.getDocContentById(docId).subscribe(
      (doc: MyDocsModel) => {
        this.showPdf(doc?.comm_doc_str, doc?.doc_name || docName);
      },
      () => {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to load document');
      }
    );
  }

  initializeColumns() {
    this.userDocTableColumns = [
      { name: 'Document Name', dataKey: 'doc_name', isSortable: true },
      { name: 'Description', dataKey: 'doc_desc', isSortable: true },
      { name: 'Effective Date', dataKey: 'effective_dt', isSortable: true },
      { name: 'Commission Plan', dataKey: 'comm_plan_desc', isSortable: true },
      { name: 'Uploaded Date', dataKey: 'uploadedDt', isSortable: true },
      { name: 'Status', dataKey: 'status', isSortable: true }
    ];
  }

  public onExcelExport = (): void => {
    if (!this.docNames || this.docNames.length === 0) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'No data to export');
      return;
    }

    const headers = this.userDocTableColumns.map(column => column.name);
    const data = this.docNames.map(row =>
      this.userDocTableColumns.map(column => {
        const value = row[column.dataKey];
        return value === null || value === undefined ? '' : value;
      })
    );

    this.exportExcelService.exportExcel({
      title: 'User-Doc-Mapping',
      headers,
      data
    });
  };

  onRowAction(event: any) {
    if (!event || !event.row) {
      return;
    }

    const action = event.value ? event.value.toLowerCase() : '';

    if (action === 'view') {
      this.viewDocumentById(event.row.id, event.row.doc_name);
    } else if (action === 'upload') {
      this.uploadRow = event.row;
      this.clickButton('UploadDoc');
    } else if (action === 'edit') {
      this.editRow = { ...event.row };
      this.clickButton('EditDoc');
    } else if (event.name === 'checkbox') {
      this.selectedDoc(event.row, { currentTarget: { checked: event.value } });
    }
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
     const file = event.target.files[0];
     if (this.validatePDFFile(file)) {
      this.uploadFile = file;
     } else { 
      event.target.value = ''
      this.uploadFile = null;
     }
    } else {
      this.uploadFile = null; 
    }
  }

  onUploadConfirm() {
    if (this.uploadFile && this.uploadRow) {
      this.myDocsService.uploadSingleDoc(this.uploadFile, this.uploadRow.id).subscribe(
              event=> {
          if(event.type === HttpEventType.UploadProgress) {
        } else if (event instanceof HttpResponse) {
          console.log("upload completed, sending notification");
          this.notificationService.sendNotification(NotificationType.SUCCESS, 'Document uploaded successfully');
          this.getMyDocsList();
          this.uploadFile = null;
          this.uploadRow = null;
          this.clickToCloseButton('closeUploadButton');
        }
      },
        error => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to upload document');
          this.uploadFile = null;
        }
      );    
    }
  }

  onUploadCancel() {
    this.uploadFile = null;
    this.uploadRow = null;
  }

  closeEditModal() {
    this.editRow = null;
  }

  private clickButton(buttonId: string): void {
    const element = document.getElementById(buttonId);
    if (element) {
      element.click();
    }
  }

  public clickToCloseButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  saveEditRow() {
    if (!this.editRow) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'No data to update');
      return;
    }

    this.editRow.updated_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

    this.myDocsService.updateDocs([this.editRow]).subscribe(
      response => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Document updated successfully');
        this.closeEditModal();
        this.clickToCloseButton('closeEditButton');
        this.getMyDocsList();
      },
      error => {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to update document');
      }
    );
  }

  loadCommissionPlans(): void {
    this.myDocsService.getCommPlanDescList().subscribe(
      (plans: any[]) => {
        this.commissionPlans = plans;
      },
      error => {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to load commission plans');
      }
    );
  }

  initializeGridConfiguration(): void {
    this.actions = [
      {
        name: 'View',
        dataKey: 'far fa-eye success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Upload',
        dataKey: 'fas fa-upload success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-primary'
      },
      {
        name: 'Edit',
        dataKey: 'fas fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-warning'
      }
    ];

    this.actionButtons = [
      {
        name: 'Add Document',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Active',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Inactive',
        class: 'btn btn-danger btn-xs'
      }
    ];
  }

  actionOnButton(action: string): void {
    if (this.isAccessDisabled) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      return;
    }

    switch (action) {
      case 'Add Document':
        this.showAddDocumentForm();
        break;
      case 'Active':
        this.activeSelectedDocuments();
        break;
      case 'Inactive':
        this.inactiveSelectedDocuments();
        break;
    }
  }

 onAssignedDocSelectAllChange(event: any): void {
  const nativeEvent = event?.value;  
  const isChecked = nativeEvent?.target?.checked;
 
  console.log('selectAllAction native event:', nativeEvent);
  console.log('isChecked:', isChecked);
 
  if (isChecked) {
    this.selectedUserDocuments = [...this.docNames];
  } else {
    this.selectedUserDocuments = [];
  }
 
  this.headerCheckboxSelected = !!isChecked;
}
 
update(event: any): void {
  const isChecked = event.value?.currentTarget?.checked;
  const row = event.row;
 
  if (!row || isChecked === undefined) return;
 
  if (isChecked) {
    if (!this.selectedUserDocuments.some(doc => doc.id === row.id)) {
      this.selectedUserDocuments.push(row);
    }
  } else {
    this.selectedUserDocuments = this.selectedUserDocuments.filter(doc => doc.id !== row.id);
  }
 
  this.headerCheckboxSelected = this.selectedUserDocuments.length === this.docNames.length;
}
 
  changed(event: any): void {
    if (event.value.currentTarget.checked) {
      this.filterAllDocuments();
    } else {
      this.filterActiveDocuments();
    }
  }
 
  private activeSelectedDocuments(): void {
    if (this.selectedUserDocuments.length === 0) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select documents to activate');
      return;
    }
 
    const documentsToUpdate = this.selectedUserDocuments.map(doc => ({
      ...doc,
      status: 'Active',
      updated_by: localStorage.getItem('CURRENT_USER_NAME_SESSION')
    }));
 
    this.myDocsService.updateDocs(documentsToUpdate).subscribe(
      response => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Documents Active successfully');
        this.getMyDocsList();
        this.selectedUserDocuments = [];
        this.clearSelectionAndRefresh();
      },
      error => {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to Active documents');
      }
    );
  }
 
  private inactiveSelectedDocuments(): void {
    if (this.selectedUserDocuments.length === 0) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Please select documents to Inactive');
      return;
    }
 
    const documentsToUpdate = this.selectedUserDocuments.map(doc => ({
      ...doc,
      status: 'Inactive',
      updated_by: localStorage.getItem('CURRENT_USER_NAME_SESSION')
    }));
 
    this.myDocsService.updateDocs(documentsToUpdate).subscribe(
      response => {
        this.notificationService.sendNotification(NotificationType.SUCCESS, 'Documents Inactive successfully');
        this.getMyDocsList();
        this.selectedUserDocuments = [];
        this.clearSelectionAndRefresh();
      },
      error => {
        this.notificationService.sendNotification(NotificationType.ERROR, 'Failed to dInactive documents');
      }
    );
  }
 
  private clearSelectionAndRefresh(): void {
    this.selectedUserDocuments=[];
    this.headerCheckboxSelected =false;
    this.getMyDocsList();
    this.showTable = false;
    setTimeout(()=> {
      this.showTable = true;
    }, 0);
  }

  private filterActiveDocuments(): void {
    this.docNames = this.userDocMapData.filter(doc => {
      return doc.status && doc.status.toString().toLowerCase() === 'active';
    });
  }

  private filterAllDocuments(): void {
    this.docNames = [...this.userDocMapData];
  }

  // Add Document functionality methods (from add-commission-doc component)
  public showAddDocumentForm(): void {
    this.showAddDocForm = true;
    this.addDocModel = new MyDocsModel();
    this.addDocSelectedFiles = undefined;
    this.addDocCurrentFile = undefined;
    this.addDocProgress = 0;
    this.addDocMessage = '';

    // Reset file input and any validation states
    setTimeout(() => {
      this.resetFileInput();
      this.resetFormValidation();
    }, 100);

    // Load sales channels when opening the form
    this.getSalesChannelsList();
    this.clickButton('AddDocumentModal');
  }

  public hideAddDocumentForm(): void {
    this.showAddDocForm = false;
    this.addDocModel = new MyDocsModel();
    this.addDocSelectedFiles = undefined;
    this.addDocCurrentFile = undefined;
    this.addDocProgress = 0;
    this.addDocMessage = '';
  }

  public getSalesChannelsList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getSalesChannelsList().subscribe(
        (response: MyDocsModel[]) => {
          this.salesChannelsData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.message || 'Failed to load sales channels');
        }
      )
    );
  }

  public getCommPlanList(): void {
    // Only load commission plans if sales channel is selected
    if (!this.addDocModel.salesChannelDesc) {
      this.commPlanDescData = [];
      return;
    }
    this.refreshing = true;
    this.subscriptions.push(
      this.myDocsService.getCommPlanList(this.addDocModel.salesChannelDesc).subscribe(
        (response: MyDocsModel[]) => {
          this.commPlanDescData = response;
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.message || 'Failed to load commission plans');
        }
      )
    );
  }

  selectFileForNewDoc(event) {
    if (event.target.files && event.target.files.length > 0) {
     const file = event.target.files[0];
     if (this.validatePDFFile(file)) {
      this.addDocSelectedFiles = event.target.files;
     } else { 
      event.target.value = ''
      this.addDocSelectedFiles = undefined;
     }
    } else {
      this.addDocSelectedFiles = undefined;
    }
  }

  uploadNewDoc() {
    if (this.addDocModel.doc_name === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Enter Document Name!');
    } else if (this.addDocModel.doc_desc === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Enter Document Description!');
    } else if (this.addDocModel.effective_dt === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Effective Date!');
    } else if (this.addDocModel.salesChannelDesc === "" || this.addDocModel.salesChannelDesc === null) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Sales Channel!');
    } else if (this.addDocModel.comm_plan_id === "") {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Select Commission Plan!');
    } else if (this.addDocSelectedFiles === undefined) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Please Choose File !');
    } else {
      this.addDocProgress = 0;
      this.addDocCurrentFile = this.addDocSelectedFiles.item(0);
      console.log('Starting upload with comm_plan_id:', this.addDocModel.comm_plan_id);
      this.myDocsService.uploadDocs(this.addDocCurrentFile, this.addDocModel.doc_name, this.addDocModel.doc_desc, this.addDocModel.comm_plan_id, this.addDocModel.effective_dt).subscribe(
        event => {
          if (event.type === HttpEventType.UploadProgress) {
            this.addDocProgress = Math.round(100 * event.loaded / event.total);
          } else if (event instanceof HttpResponse) {
            this.addDocMessage = event.body.message;
            // Clear form and refresh list only on successful completion
            this.addDocModel.doc_name = "";
            this.addDocModel.doc_desc = "";
            this.addDocModel.comm_plan_id = "";
            this.addDocModel.salesChannelDesc = "";
            this.addDocModel.effective_dt = null;

            // Reset file input
            this.resetFileInput();
            this.resetFormValidation();

            this.notificationService.sendNotification(NotificationType.SUCCESS, 'Uploaded Successfully');
            this.hideAddDocumentForm();
            this.clickToCloseButton('closeAddDocButton');
            this.getMyDocsList();
          }
        },
        err => {
          this.notificationService.sendNotification(NotificationType.ERROR, 'Could not upload the file!');
          this.addDocProgress = 0;
          this.addDocMessage = 'Could not upload the file!';
        });

      this.addDocSelectedFiles = undefined;
    }
  }

  // method to reset file input
  private resetFileInput(): void {
    try {
      const fileInput = document.querySelector('#addDocumentModal input[type="file"]') as HTMLInputElement;
      if (fileInput) {
        fileInput.value = '';
      }
    } catch (error) {
      console.log('Could not reset file input:', error);
    }
  }

  // method to reset form validation states
  private resetFormValidation(): void {
    try {
      // Remove validation classes from all form inputs in the add document modal
      const modal = document.querySelector('#addDocumentModal');
      if (modal) {
        const inputs = modal.querySelectorAll('input, select');
        inputs.forEach((input: Element) => {
          const htmlInput = input as HTMLElement;
          htmlInput.classList.remove('ng-invalid', 'ng-dirty', 'ng-touched');
          htmlInput.classList.add('ng-pristine', 'ng-untouched');
        });
      }
    } catch (error) {
      console.log('Could not reset form validation:', error);
    }
  }

  private validatePDFFile(file: File): boolean {
    if (!file) {
      return false;
    }
    const fileName = file.name.toLowerCase();
    if (!fileName.endsWith('.pdf')) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'Only PDF files are allowed. Please select a PDF file.');
      return false;
    }
    return true;
  }

}
